<div class="modal">
  <div class="create-new-branch">
    <div class="header">
      <h2 i18n="@@create_new_branch.header.add_branch">Add branch</h2>
      <span (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
          <path d="M24 8.5L8 24.5M8 8.5L24 24.5" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <form class="mbranch-row" [formGroup]="storeInformationForm" (ngSubmit)="onSubmit()" id="ngForm" #informationForm="ngForm">
      <div class="mbranch-col">
        <div 
          class="mbranch-illustration" 
          [ngStyle]="{ 'cursor': isDragging ? 'grabbing' : 'grab' }"
          (mousemove)="onMouseMove($event)" 
          (mouseup)="onMouseUp()"
          (mouseleave)="onMouseUp()"
        >
          <img 
            [src]="coverPhoto" 
            [ngStyle]="{ top: position.top + 'px', left: position.left + 'px' }" 
            class="mbranch-illustration__image"
            (mousedown)="onMouseDown($event)" 
            alt="store image"
            *ngIf="coverPhoto"
          />
          <label for="cover_image" class="mbranch-illustration__image w-100 h-100 border" *ngIf="!coverPhoto" style="border-radius: 1.5rem;"></label>

          <div class="mbranch-illustration__actions">
            <label class="mbranch-illustration__change">
              <span i18n="@@create_new_branch.change_cover_photo" *ngIf="!isTemplateData">Change cover photo</span>
              <span i18n="@@create_new_branch.upload_cover_photo" *ngIf="isTemplateData">Upload cover photo</span>
              <input type="file" hidden (change)="onChangePhoto($event)" id="cover_image" formControlName="cover_image"/>
            </label>
            <!-- <button type="button" class="mbranch-illustration__reposition">
              Reposition
            </button> -->
          </div>
        </div>
        <!-- <file-pond #logoFile [options]="pondOptions" [files]="coverImageUrl" (oninit)="pondHandleInit()"
          (onaddfile)="pondHandleAddFile($event)" (onprocessfileabort)="pondHandleRemoveFile($event)">
        </file-pond> -->

        <div class="mbranch-desc">
          <span class="mbranch-label" i18n="@@branches.tpl.business_type">Business Type</span>
          <div class="mbranch-value" *ngIf="!editBusinessType">
            <span>{{ selectedBusinessType }}</span>
            <!-- <button class="mbranch-edit" (click)="editBusinessType = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M21.0001 11.6666L16.3334 6.99995M2.91675 25.0833L6.86518 24.6446C7.34758 24.591 7.58879 24.5642 7.81423 24.4912C8.01425 24.4264 8.2046 24.3349 8.38012 24.2192C8.57794 24.0888 8.74955 23.9171 9.09276 23.5739L24.5001 8.16661C25.7888 6.87795 25.7888 4.78861 24.5001 3.49995C23.2114 2.21128 21.1221 2.21128 19.8334 3.49994L4.4261 18.9073C4.08289 19.2505 3.91128 19.4221 3.78082 19.6199C3.66509 19.7954 3.5736 19.9858 3.50885 20.1858C3.43586 20.4112 3.40906 20.6524 3.35546 21.1349L2.91675 25.0833Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button> -->
          </div>
          <div class="radio-group" *ngIf="editBusinessType">
            <label class="radio-wrapper" *ngFor="let type of businessTypes">
              <input
                type="radio"
                name="businessType"
                [value]="type"
                [(ngModel)]="selectedBusinessType"  
              />
              <span class="custom-radio"></span>
              {{ type }}
            </label>
            <button class="submit-btype" (click)="editBusinessType = false">submit</button>
          </div>          
        </div>
        <!-- <div class="mbranch-desc">
          <span class="mbranch-label">Categories</span>
          <div class="mbranch-value">
            <div class="badges-track">
              <span class="mbranch-cat__badge" *ngFor="let cat of categories; let i = index">
                {{ cat }}
                <button *ngIf="editCategories" class="remove-btn" (click)="removeCategory(i)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                    <path d="M12 4L4 12M4 4L12 12" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </span>
            </div>
            <button class="mbranch-edit" (click)="editCategories = !editCategories">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M21.0001 11.6666L16.3334 6.99995M2.91675 25.0833L6.86518 24.6446C7.34758 24.591 7.58879 24.5642 7.81423 24.4912C8.01425 24.4264 8.2046 24.3349 8.38012 24.2192C8.57794 24.0888 8.74955 23.9171 9.09276 23.5739L24.5001 8.16661C25.7888 6.87795 25.7888 4.78861 24.5001 3.49995C23.2114 2.21128 21.1221 2.21128 19.8334 3.49994L4.4261 18.9073C4.08289 19.2505 3.91128 19.4221 3.78082 19.6199C3.66509 19.7954 3.5736 19.9858 3.50885 20.1858C3.43586 20.4112 3.40906 20.6524 3.35546 21.1349L2.91675 25.0833Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div> -->
        <div class="form-group">
						<div class="status_wrap w-100 w-none-100 store-information--box">
							<fieldset class="add-categories mb-0" [ngClass]="{ 'has-error': (isSubmitted || f.storefront_categories.dirty) && f.storefront_categories?.errors }">
								<label class="mbranch-label" i18n="@@branches.tpl.add_categories">Add Categories</label>
								<select class="categories select2-hidden-accessible" app-select2-multiple [options]="{ajax: {url: storeFrontCategoriesApi}, idColumn: 'name',textColumn: 'name', maxLength: 3}" [selected]="selectedStorefrontCategories ? selectedStorefrontCategories : null" i18n-data-placeholder="@@store.add_storefront_categories" data-placeholder="Add Storefront Categories" formControlName="storefront_categories" multiple="multiple"></select>
								<span class="field-error" *ngIf="(isSubmitted || f.storefront_categories.dirty) && f.storefront_categories.errors?.required">Add at least one category</span>
								<span class="field-error" *ngIf="f.storefront_categories.errors?.serverError">{{ f.storefront_categories.errors?.serverError }}</span>
							</fieldset>
						</div>
				</div>


        <div class="mbranch-desc">
          <span class="mbranch-label" i18n="@@create_new_branch.shop_comments">Shop Comments</span>
          <div class="mbranch-value sm">
            <!-- <span>Please note that any orders placed after 05:00 PM will be rejected.</span> -->
             <textarea placeholder="e.g Please note any orders placed past 5pm will be rejected"
										formControlName="shop_comments"></textarea>
            <button type="button" class="mbranch-edit">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M21.0001 11.6666L16.3334 6.99995M2.91675 25.0833L6.86518 24.6446C7.34758 24.591 7.58879 24.5642 7.81423 24.4912C8.01425 24.4264 8.2046 24.3349 8.38012 24.2192C8.57794 24.0888 8.74955 23.9171 9.09276 23.5739L24.5001 8.16661C25.7888 6.87795 25.7888 4.78861 24.5001 3.49995C23.2114 2.21128 21.1221 2.21128 19.8334 3.49994L4.4261 18.9073C4.08289 19.2505 3.91128 19.4221 3.78082 19.6199C3.66509 19.7954 3.5736 19.9858 3.50885 20.1858C3.43586 20.4112 3.40906 20.6524 3.35546 21.1349L2.91675 25.0833Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="mbranch-desc">
          <div class="mbranch-row">
            <span class="mbranch-label full" i18n="@@create_new_branch.working_hours">Working hours</span>
            <button type="button" class="mbranch-edit" (click)="editSchedule = !editSchedule">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M21.0001 11.6666L16.3334 6.99995M2.91675 25.0833L6.86518 24.6446C7.34758 24.591 7.58879 24.5642 7.81423 24.4912C8.01425 24.4264 8.2046 24.3349 8.38012 24.2192C8.57794 24.0888 8.74955 23.9171 9.09276 23.5739L24.5001 8.16661C25.7888 6.87795 25.7888 4.78861 24.5001 3.49995C23.2114 2.21128 21.1221 2.21128 19.8334 3.49994L4.4261 18.9073C4.08289 19.2505 3.91128 19.4221 3.78082 19.6199C3.66509 19.7954 3.5736 19.9858 3.50885 20.1858C3.43586 20.4112 3.40906 20.6524 3.35546 21.1349L2.91675 25.0833Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="mbranch-schedule" formGroupName="week_days">
            <div class="innerbox-row d-flex" *ngIf="editSchedule">
              <div class="form-group w-auto mr-3 row fit">
                <div class="custom-checkbox">
                  <input class="select-item" type="checkbox" id="everyday" (change)="onCheckboxChange($event, everyday.uuid)" formControlName="same_everyday" />
                  <svg *ngIf="!everyday.selected" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24" fill="none">
                    <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
                  </svg>
                  <svg *ngIf="everyday.selected" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2" />
                    <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <label class="mbranch-label" for="everyday" i18n="@@branches.tpl.same_everyday">Same
                  everyday</label>
              </div>
              <div class="form-group w-auto row fit">
                <div class="custom-checkbox">
                  <input class="select-item" type="checkbox" id="is24HoursOpen" (change)="onCheckboxChange($event, is24HoursOpen.uuid)" formControlName="is_24hour" />
                  <svg *ngIf="!is24HoursOpen.selected" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24" fill="none">
                    <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
                  </svg>
                  <svg *ngIf="is24HoursOpen.selected" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2" />
                    <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <label class="mbranch-label" for="is24HoursOpen" i18n="@@branches.tpl.open_24_hours">24-hours
                  open</label>
              </div>
            </div>
            <ng-container *ngIf="!editSchedule">
              <div class="mbranch-schedule__item" *ngFor="let item of filteredSchedule">
                <ng-container [ngSwitch]="item.day">
									<span *ngSwitchCase="'Monday'" i18n="@@monday" class="days">Monday</span>
									<span *ngSwitchCase="'Tuesday'" i18n="@@tuesday" class="days">Tuesday</span>
									<span *ngSwitchCase="'Wednesday'" i18n="@@wednesday" class="days">Wednesday</span>
									<span *ngSwitchCase="'Thursday'" i18n="@@thursday" class="days">Thursday</span>
									<span *ngSwitchCase="'Friday'" i18n="@@friday" class="days">Friday</span>
									<span *ngSwitchCase="'Saturday'" i18n="@@saturday" class="days">Saturday</span>
									<span *ngSwitchCase="'Sunday'" i18n="@@sunday" class="days">Sunday</span>
								</ng-container>
                <div class="schedule-time">
                  <span *ngFor="let slotTime of item.slot; let j = index"><span *ngIf="j > 0">, </span>{{ slotTime.start || '--:--' }} - {{ slotTime.end || '--:--' }}</span>
                </div>
              </div>
            </ng-container>            
            <div *ngIf="editSchedule" class="mbranch-schedule__list">
              <div class="schedule-item" *ngFor="let day of schedule; let i = index">
                <!-- <div class="schedule-item__toggle">
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="day.active" />
                    <span class="slider"></span>
                  </label>
                  <span class="days">{{ day.day }}</span>
                  <span class="summary" *ngIf="day.active && !day.expanded">{{ day.start || '--:--' }} - {{ day.end || '--:--' }}</span>
                  <button class="dropdown-toggle" (click)="toggleDropdown(i)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 25 24">
                      <path d="M6.66675 9L12.6667 15L18.6667 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
                <div class="schedule-time" *ngIf="day.active && day.expanded">
                  <input type="time" [(ngModel)]="day.start" /> –
                  <input type="time" [(ngModel)]="day.end" />
                </div> -->
                <ng-container [formGroupName]="(day.day).toLowerCase()">
                  <div class="schedule-item__toggle">
                    <label class="switch">
                      <input type="checkbox" formControlName="available" />
                      <span class="slider"></span>
                    </label>
                    <ng-container [ngSwitch]="day.day">
                      <span *ngSwitchCase="'Monday'" i18n="@@monday" class="days">Monday</span>
                      <span *ngSwitchCase="'Tuesday'" i18n="@@tuesday" class="days">Tuesday</span>
                      <span *ngSwitchCase="'Wednesday'" i18n="@@wednesday" class="days">Wednesday</span>
                      <span *ngSwitchCase="'Thursday'" i18n="@@thursday" class="days">Thursday</span>
                      <span *ngSwitchCase="'Friday'" i18n="@@friday" class="days">Friday</span>
                      <span *ngSwitchCase="'Saturday'" i18n="@@saturday" class="days">Saturday</span>
                      <span *ngSwitchCase="'Sunday'" i18n="@@sunday" class="days">Sunday</span>
                    </ng-container>
                    <span class="summary" *ngIf="day.active && !day.expanded">
                      <span *ngFor="let slotTime of day.slot; let j = index"><span *ngIf="j > 0">, </span>{{ slotTime.start || '--:--' }} - {{ slotTime.end || '--:--' }}</span>
                    </span>
                    <button type="button" class="dropdown-toggle" (click)="toggleDropdown(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
                        viewBox="0 0 25 24">
                        <path d="M6.66675 9L12.6667 15L18.6667 9" stroke="#0A0A0A" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
                  <div class="schedule-time" *ngIf="day.active && day.expanded">
                    <div formArrayName="slots" class="w-100">
                      <div class="gap-2 align-items-center d-flex pb-3" *ngFor="let slot of getSlots((day.day).toLowerCase()).controls; let i = index" [formGroupName]="i">
                        <fieldset class="mb-0" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
                          <input type="time" formControlName="start_time" /> 
                          <span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>
                          <span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
                        </fieldset>
                        –
                        <fieldset  class="mb-0" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
                          <input type="time" formControlName="end_time" />
                          <span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>
                          <span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
                        </fieldset>

                        <span *ngIf="getSlots((day.day).toLowerCase()).length > 1 && i > 0" role="button" (click)="removeSlot((day.day).toLowerCase(), i)">
                          <svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                        </span>

                        <!-- ADD BUTTON -->
                        <span *ngIf="i == 0" role="button" (click)="addSlot((day.day).toLowerCase())">
                          <svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="field-error" i18n="@@error.start_time_required" *ngIf="storeInformationForm.get('week_days.' + (day.day).toLowerCase() + '.start_time')?.hasError('required')">Start time is required</div>
                  <div class="field-error" i18n="@@error.end_time_required" *ngIf="storeInformationForm.get('week_days.' + (day.day).toLowerCase() + '.end_time')?.hasError('required')">End time is required</div> -->
                </ng-container>
              </div>
            </div>
          </div>          
        </div>
      </div>
      <div class="mbranch-col">
        <div class="mbranch-row sm">
          <!-- <div class="form-group">
            <label class="mbranch-label" for="branchName" i18n="@@create_new_branch.branch_name">Branch Name</label>
            <input id="branchName" type="text" class="form-control" placeholder="Enter specific branch name" formControlName="name" />
          </div>
          <div class="form-group">
            <label class="mbranch-label" for="link" i18n="@@create_new_branch.store_link">Store Link (Useful for sending URLs to customers)</label>
            <input id="link" type="text" class="form-control" placeholder="www.app.teem-app.com/branch-name" />
          </div> -->
          <fieldset class="form-group" [ngClass]="{ 'has-error': (isSubmitted || f.name.dirty) && f.name?.errors }">
            <label class="mbranch-label" for="storeName" i18n="@@business.business_name">Business Name</label>
            <input id="storeName" class="form-control" type="text" name="store-name" formControlName="name"
              (keyup)="convertToSlug($event.target.value)" (blur)="convertToSlug($event.target.value)" />
            <span class="field-error" i18n="@@error.required.store_name"
              *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.required">Store name is required</span>
            <span class="field-error" *ngIf="f.name.errors?.serverError">{{ f.name.errors?.serverError }}</span>
          </fieldset>
          <fieldset class="form-group" [ngClass]="{ 'has-error': (isSubmitted || f.slug.dirty) && f.slug?.errors }">
            <label class="mbranch-label" for="link" i18n="@@create_new_branch.store_link">Store Link (Useful for sending URLs to customers)</label>
            <input id="link" type="text" class="form-control" placeholder="www.app.teem-app.com/branch-name"
              name="catalogue_link" #slug formControlName="slug" (keyup)="convertToSlug(slug.value)"
              (blur)="convertToSlug(slug.value)" />
            <span class="field-error" i18n="@@error.required"
              *ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.required">Required</span>
            <span class="field-error" i18n="@@error.slug_taken"
              *ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.slugTaken">Slug is already taken</span>
            <span class="field-error" *ngIf="f.slug.errors?.serverError">{{ f.slug.errors?.serverError }}</span>
            <span class="catalogue-details__businessUrl">{{ storeUrl }}</span>
          </fieldset>
        </div>
        <div class="form-group row">
          <input type="hidden" formControlName="branch_id">
          <div class="custom-checkbox">
            <input 
              class="select-item" 
              type="checkbox" 
              formControlName="do_not_show_storefront"
              (change)="storeFrontCheckbox($event)">
            <svg *ngIf="!storefront_selected" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
            </svg>
            <svg *ngIf="storefront_selected" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
              <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>          
          <label class="mbranch-label" for="storefront" i18n="@@create_new_branch.do_not_show_storefront">Do not show branch on global storefront</label>
        </div>
        <div class="mbranch-innerbox">
          <h2 i18n="@@create_new_branch.store_location">Store location</h2>
          <div
						class="user_info_container gap-4 d-flex justify-content-between align-items-center flex-row flex-none-column align-items-none-start">
						<div class="w-50 service_hide  w-none-100">
							<fieldset
								[ngClass]="{ 'has-error': (isSubmitted || f.address.dirty) && f.address?.errors }">
								<label class="mbranch-label"> <ng-container i18n="@@google_pin_drop_location">Google pin drop location
									</ng-container> <a class="city-link" href="javascript:void(0)"
										(click)="openGoogleMap()" i18n="@@open_map"> open map</a></label>
								<input type="text" name="drop-location" formControlName="address" readonly>
								<span class="field-error" i18n="@@error.required.address"
									*ngIf="(isSubmitted || f.address.dirty) && f.address.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.address.errors?.serverError">{{
									f.address.errors?.serverError }}</span>
							</fieldset>
						</div>
						<div class="w-50 service_hide"></div>
					</div>

					<div
						class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.building_name.dirty) && f.building_name?.errors }">
								<label class="mbranch-label" i18n="@@business.building_name">Building Name</label>
								<input type="text" name="building_name" formControlName="building_name"
									(keypress)="validateInput($event)" />
								<span class="field-error" i18n="@@error.required.building_name"
									*ngIf="(isSubmitted || f.building_name.dirty) && f.building_name.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.building_name.errors?.serverError">{{
									f.building_name.errors?.serverError }}</span>
							</fieldset>
						</div>
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.street.dirty) && f.street?.errors }">
								<label class="mbranch-label" i18n="@@business.street">Street</label>
								<input type="text" name="street" formControlName="street"
									(keypress)="validateInput($event)" />
								<span class="field-error" i18n="@@error.required.street"
									*ngIf="(isSubmitted || f.street.dirty) && f.street.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.street.errors?.serverError">{{
									f.street.errors?.serverError }}</span>
							</fieldset>
						</div>
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.area.dirty) && f.area?.errors }">
								<label class="mbranch-label" i18n="@@business.area">Area</label>
								<input type="text" name="area" formControlName="area"
									(keypress)="validateInput($event)" />
								<span class="field-error" i18n="@@error.required.area"
									*ngIf="(isSubmitted || f.area.dirty) && f.area.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.area.errors?.serverError">{{
									f.area.errors?.serverError }}</span>
							</fieldset>
						</div>
					</div>

					<div
						class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.country_id.dirty) && f.country_id?.errors }">
								<label class="mbranch-label" i18n="@@store.country">Country</label>
								<select app-select2 [options]="{
                  ajax: {url: countryListApi},
                  idColumn: 'id',
                  textColumn: 'name'
                }" (itemSelected)="onChangeCountry($event)"
									[selected]="selectedCountry ? {id: selectedCountry?.id, text: selectedCountry?.name} : null"
									i18n-placeholder="@@business.country_placeholder"
									placeholder="Please type country name" name="country_id"
									formControlName="country_id">
									<option></option>
								</select>
								<span class="field-error" i18n="@@error.required"
									*ngIf="(isSubmitted || f.country_id.dirty) && f.country_id.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.country_id.errors?.serverError">{{
									f.country_id.errors?.serverError }}</span>
							</fieldset>
						</div>

						<ng-container *ngIf="outsideSA; else insideSA">
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.city.dirty) && f.city?.errors }">
									<label class="mbranch-label" i18n="@@store.city">City</label>
									<input type="text" name="city" formControlName="city">
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.city.dirty) && f.city.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.city.errors?.serverError">{{
										f.city.errors?.serverError }}</span>
								</fieldset>
							</div>
						</ng-container>
						<ng-template #insideSA>
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.region_id.dirty) && f.region_id?.errors }">
									<label class="mbranch-label" i18n="@@store.region">Region</label>
									<select app-select2 [options]="{
                    ajax: {url: regionListApi},
                    idColumn: 'id',
                    textColumn: 'name'
                  }" (itemSelected)="onChangeRegion($event)"
										[selected]="selectedRegion ? {id: selectedRegion.id, text: selectedRegion.name}  : {}"
										i18n-placeholder="@@store.please_select" data-placeholder="Select Region"
										formControlName="region_id">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.region_id.dirty) && f.region_id.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.region_id.errors?.serverError">{{
										f.region_id.errors?.serverError }}</span>
								</fieldset>
							</div>
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.city_id.dirty) && f.city_id?.errors }">
									<label class="mbranch-label" i18n="@@store.city">City</label>
									<select app-select2 [options]="{
                    data: cities ? cities : [],
                    idColumn: 'id',
                    textColumn: 'name'
                  }" [params]="{cityId:f.region_id.value}" (itemSelected)="onChangeCity($event)"
										[selected]="selectedCity ? {id: selectedCity.id, text: selectedCity.name}  : {}"
										i18n-placeholder="@@store.please_select" placeholder="Select City"
										data-placeholder="Select City" formControlName="city_id">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.city_id.dirty) && f.city_id.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.city_id.errors?.serverError">{{
										f.city_id.errors?.serverError }}</span>
								</fieldset>
							</div>
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.district_id.dirty) && f.district_id?.errors }">
									<label class="mbranch-label" i18n="@@store.district">District</label>
									<select app-select2 [options]="{
                    data: districts ? districts : [],
                    idColumn: 'id',
                    textColumn: 'name'
                  }" [selected]="selectedDistrict ? {id: selectedDistrict.id, text: selectedDistrict.name}  : {}"
										i18n-placeholder="@@store.please_select" placeholder="Select District"
										data-placeholder="Select District" formControlName="district_id">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.district_id.dirty) && f.district_id.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.district_id.errors?.serverError">{{
										f.district_id.errors?.serverError }}</span>
								</fieldset>
							</div>
						</ng-template>
					</div>
        </div>
        <div class="form-group">
          <label class="mbranch-label" for="desc" i18n="@@create_new_branch.description">Description</label>
          <textarea id="desc" class="form-control" placeholder="Enter business description" rows="4" formControlName="description"></textarea>
        </div>
        <!-- <div class="form-group">
						<div class="status_wrap w-100 w-none-100 store-information--box">
							<fieldset class="add-categories pb-4" [ngClass]="{ 'has-error': (isSubmitted || f.storefront_categories.dirty) && f.storefront_categories?.errors }">
								<label class="mbranch-label" i18n="@@branches.tpl.add_categories">Add Categories</label>
								<select class="categories select2-hidden-accessible" app-select2-multiple [options]="{ajax: {url: storeFrontCategoriesApi}, idColumn: 'name',textColumn: 'name', maxLength: 3}" [selected]="selectedStorefrontCategories ? selectedStorefrontCategories : null" i18n-data-placeholder="@@store.add_storefront_categories" data-placeholder="Add Storefront Categories" formControlName="storefront_categories" multiple="multiple"></select>
								<span class="field-error" *ngIf="(isSubmitted || f.storefront_categories.dirty) && f.storefront_categories.errors?.required">Add at least one category</span>
								<span class="field-error" *ngIf="f.storefront_categories.errors?.serverError">{{ f.storefront_categories.errors?.serverError }}</span>
							</fieldset>
						</div>
				</div> -->
        <div class="mbranch-row sm">
          <fieldset class="form-group" [ngClass]="{ 'has-error': (isSubmitted || f.phone.dirty) && f.phone?.errors }">
            <label class="mbranch-label" i18n="@@create_new_branch.contact_number" for="num">Contact Number</label>
            <input id="num" type="text" class="form-control" placeholder="Enter contact number" formControlName="phone"/>
            <span i18n="@@error.required.contact" class="field-error" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.required">Phone number is required </span>
            <span class="field-error" i18n="@@error.phone_number_only" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.pattern">Please enter number only </span>
            <span class="field-error" i18n="@@error.required.contact_number_between" *ngIf="(isSubmitted || f.phone.dirty) && (f.phone.errors?.minlength || f.phone.errors?.maxlength)">The phone number must be less than 5 and 30 digits</span>
          </fieldset>
          <fieldset class="form-group" [ngClass]="{ 'has-error': (isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone?.errors }">
            <label class="mbranch-label" for="whatsapp" i18n="@@create_new_branch.whatsapp_number">Whatsapp Business Number </label>
            <div class="input-with-prefix">
              <span class="prefix">https://wa.me/</span>
              <input
                id="whatsapp"
                type="text"
                class="form-control"
                placeholder="+966 123 456 789"
                formControlName="whatsapp_phone"
              />
            </div>  
            <span i18n="@@error.required.contact" class="field-error" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.required">Whatsapp number is required </span>
            <span class="field-error" i18n="@@error.whatsapp_phone_number_only" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.pattern">Please enter number only </span>
            <span class="field-error" i18n="@@error.required.contact_number_between" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && (f.whatsapp_phone.errors?.minlength || f.whatsapp_phone.errors?.maxlength)">The Whatsapp number must be less than 5 and 30 digits</span>
															<span class="field-error" *ngIf="f.whatsapp_phone.errors?.serverError">{{ f.whatsapp_phone.errors?.serverError }}</span>          
          </fieldset>
        </div>
        
        <div class="mbranch-innerbox" *ngIf="basicInfo.user_type == 'super_admin'">
          <h2 i18n="@@create_new_branch.assign_administrators">Assign Administrators</h2>
          <div class="mbranch-usersList">
            <!-- <div class="form-group"> -->
              <div class="status_wrap store-information--box">
                <fieldset class="add-categories">
                  <label class="mbranch-label" for="user" i18n="@@create_new_branch.add_user">Add user</label>
                  <select app-select2-multiple [options]="{
                                ajax: {url: userAllListApi},
                                idColumn: 'id',
                                textColumn: 'full_name'
                              }"
                    [selected]="selectedUser ? selectedUser : null"
                    i18n-data-placeholder="@@create_new_branch.add_user" data-placeholder="Add Users"
                    formControlName="users" multiple="multiple"></select>
                  <!-- </div> -->
                  <!-- <button type="button" class="mbranch-addUser" (click)="addAdmin()" i18n="@@create_new_branch.add_button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M10.0001 4.16675V15.8334M4.16675 10.0001H15.8334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            Add
                          </button> -->
                </fieldset>
              </div>
          </div>
          <!-- <div class="added-admin" *ngFor="let admin of addedAdmins; let i = index">
            <div class="admin-info">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                      d="M16.5 8.25a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM3.6 19.418a9.751 9.751 0 0 1 16.8 0"/>
              </svg>
              <div>
                <div class="admin-name" i18n="@@create_new_branch.admin_name">Premium Restaurant {{ admin.name }} Admin</div>
                <div class="admin-email">{{ admin.email }}</div>
              </div>
            </div>
            <button type="button" class="delete-admin" (click)="removeAdmin(i)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M16 6.20215V5.40215C16 4.28204 16 3.72199 15.782 3.29417C15.5903 2.91784 15.2843 2.61188 14.908 2.42014C14.4802 2.20215 13.9201 2.20215 12.8 2.20215H11.2C10.0799 2.20215 9.51984 2.20215 9.09202 2.42014C8.71569 2.61188 8.40973 2.91784 8.21799 3.29417C8 3.72199 8 4.28204 8 5.40215V6.20215M3 6.20215H21M19 6.20215V17.4021C19 19.0823 19 19.9224 18.673 20.5641C18.3854 21.1286 17.9265 21.5875 17.362 21.8752C16.7202 22.2021 15.8802 22.2021 14.2 22.2021H9.8C8.11984 22.2021 7.27976 22.2021 6.63803 21.8752C6.07354 21.5875 5.6146 21.1286 5.32698 20.5641C5 19.9224 5 19.0823 5 17.4021V6.20215" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div> -->
        </div>
        <button type="button" class="mbranch-submit mr-3 mb-5" i18n="@@create_new_branch.save_button" form="ngForm" (click)="informationForm.ngSubmit.emit()">Save</button>
      </div>
    </form>
  </div>
</div>